"use strict";

exports.__esModule = true;
exports.TimeseriesFixedWidthChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _createYScale = require("./createYScale");
var _Tooltip = require("./Tooltips/Tooltip");
var _ScrollableMetricChartBody = require("./ScrollableMetricChartBody");
var _ScrollableMetricChartYAxis = require("./ScrollableMetricChartYAxis");
var _XAxisLabel = require("./XAxisLabel");
var _TimeContext = require("../../../Time/TimeContext");
var _styles = require("./styles");
var _tooltipReducer = require("./Tooltips/tooltipReducer");
var _tooltipHandlers = require("./Tooltips/tooltipHandlers");
var _chartHelpers = require("./chartHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var TimeseriesFixedWidthChart = exports.TimeseriesFixedWidthChart = function TimeseriesFixedWidthChart(props) {
  var _React$useContext = _react["default"].useContext(_TimeContext.TimeContext),
    timezone = _React$useContext.timezone;
  var getYAxisCount = function getYAxisCount() {
    var hideYAxis = props.hideYAxis,
      series = props.series;
    if (hideYAxis) {
      return 0;
    }
    var seriesUnits = [];
    for (var i = 0; i < series.length; i++) {
      var unit = series[i].unit;
      if (!seriesUnits.includes(unit)) {
        seriesUnits.push(unit);
      }
    }
    return seriesUnits.length;
  };
  var series = props.series,
    _props$xAxisHeight = props.xAxisHeight,
    xAxisHeight = _props$xAxisHeight === void 0 ? 30 : _props$xAxisHeight,
    _props$padding = props.padding,
    padding = _props$padding === void 0 ? 4 : _props$padding,
    _props$hideXAxis = props.hideXAxis,
    hideXAxis = _props$hideXAxis === void 0 ? false : _props$hideXAxis,
    _props$hideXUnits = props.hideXUnits,
    hideXUnits = _props$hideXUnits === void 0 ? false : _props$hideXUnits,
    _props$hideYAxis = props.hideYAxis,
    hideYAxis = _props$hideYAxis === void 0 ? false : _props$hideYAxis,
    _props$hideYUnits = props.hideYUnits,
    hideYUnits = _props$hideYUnits === void 0 ? false : _props$hideYUnits,
    _props$minorBarPerMaj = props.minorBarPerMajorBar,
    minorBarPerMajorBar = _props$minorBarPerMaj === void 0 ? 1 : _props$minorBarPerMaj,
    _xScale = props.xScale,
    _yScales = props.yScales,
    _tickYFormat = props.tickYFormat,
    tickXFormat = props.tickXFormat,
    xAxisLabel = props.xAxisLabel,
    axisFormatter = props.axisFormatter,
    _props$builtInTooltip = props.builtInTooltip,
    builtInTooltip = _props$builtInTooltip === void 0 ? true : _props$builtInTooltip;
  var _props$minorBarSize = props.minorBarSize,
    minorBarSize = _props$minorBarSize === void 0 ? 20 : _props$minorBarSize,
    height = props.height,
    _props$yAxisWidth = props.yAxisWidth,
    yAxisWidth = _props$yAxisWidth === void 0 ? 60 : _props$yAxisWidth,
    width = props.width;
  yAxisWidth = hideYAxis ? 0 : hideYUnits ? 35 : yAxisWidth;
  var scrollBarHeight = 20;
  var XAxisLabelHeight = !(hideXUnits || hideXAxis) ? 20 : 0;
  height = height - padding;
  var paddingBetweenMajorBars = 30;
  var paddingBetweenMinorBars = 5;
  var majorBarSize = minorBarSize * minorBarPerMajorBar + (minorBarPerMajorBar - 1) * paddingBetweenMinorBars;
  var noOfMajorBars = (0, _chartHelpers.totalXAxisPartitions)(series);
  var bodyY = 0;

  /*
   * yAxisHeight:: height of the chart body (and the yAxis)
   */
  var yAxisHeight = height;
  var scrollableWidth = majorBarSize * noOfMajorBars + paddingBetweenMajorBars * (noOfMajorBars + 1);

  /*
   * bodyWidth: fixed width of the chart (check scrollableWidth for x axis width)
   * "scrollableWidth" is from x = 0 to the end of axis)
   */
  var bodyWidth = width - padding * 2;
  var yAxisCount = getYAxisCount();
  if (!hideXAxis) {
    yAxisHeight -= xAxisHeight;
  } else {
    yAxisHeight -= padding;
  }
  if (!hideYAxis) {
    bodyWidth -= yAxisWidth * yAxisCount;
  }
  if (scrollableWidth < width) {
    scrollableWidth = bodyWidth;
  }
  height = height - scrollBarHeight - XAxisLabelHeight;
  yAxisHeight = yAxisHeight - scrollBarHeight - XAxisLabelHeight;
  var xAxisWidth = bodyWidth;
  var xScale = (0, _react.useMemo)(function () {
    return _xScale(0, xAxisWidth);
  }, [scrollableWidth, majorBarSize, series]);

  /*
   *TODO:: We do not need to have multiple yScales. Hence refactor it to create and use use a single Y - Scale
   */
  var yScales = (0, _react.useMemo)(function () {
    return _yScales ? _yScales(yAxisHeight, 0, series) : (0, _createYScale.createYScales)(yAxisHeight, 0, series);
  }, [yAxisHeight, series]);
  var chart = (0, _react.useMemo)(function () {
    return series.map(_chartHelpers.normalizeSeries).map(function (item, key) {
      var unit = item.unit;
      var yScale = yScales[unit] && yScales[unit].scale;
      if (!yScale) {
        return null;
      }
      return item.render({
        key: key,
        series: item,
        x: 0,
        y: bodyY + padding,
        width: xAxisWidth,
        height: yAxisHeight,
        xScale: xScale,
        yScale: yScale,
        barWidth: minorBarSize,
        padding: paddingBetweenMinorBars
      });
    });
  }, [scrollableWidth, yAxisHeight, series]);
  var _useReducer = (0, _react.useReducer)(_tooltipReducer.tooltipReducer, _tooltipReducer.tooltipPropsInitState),
    tooltipProps = _useReducer[0],
    tooltipDispatcher = _useReducer[1];
  return /*#__PURE__*/_react["default"].createElement(_styles.FlexContainer, {
    "data-testid": "scrollable-metric-chart",
    className: "ScrollableMetricChart",
    height: height,
    style: {
      marginBottom: scrollBarHeight
    },
    onMouseLeave: (0, _tooltipHandlers.mouseLeaveHandler)(tooltipDispatcher, true)
  }, /*#__PURE__*/_react["default"].createElement(_styles.ChartWrapper, {
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_ScrollableMetricChartYAxis.ScrollableMetricChartYAxis, {
    yScales: yScales,
    bodyWidth: bodyWidth,
    yAxisWidth: yAxisWidth,
    hideYUnits: hideYUnits,
    tickYFormat: typeof _tickYFormat === "function" ? _tickYFormat : _chartHelpers.tickYFormat,
    hideYAxis: hideYAxis,
    padding: padding,
    height: yAxisHeight
  }), /*#__PURE__*/_react["default"].createElement(_Tooltip.TooltipWrapper, {
    height: yAxisHeight,
    width: xAxisWidth,
    nonScrollableWidth: bodyWidth,
    xScale: xScale,
    yScales: yScales,
    tooltipFormatters: props.tooltipFormatters,
    series: series,
    padding: padding,
    tickYFormat: typeof _tickYFormat === "function" ? _tickYFormat : _chartHelpers.tickYFormat,
    tickXFormat: tickXFormat({
      scale: xScale,
      bodyWidthToBeUsed: xAxisWidth,
      timezone: timezone
    }),
    tooltipProps: tooltipProps,
    enableTooltip: !!(builtInTooltip && props.tooltipFormatters),
    padOffset: yAxisWidth
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "scrollable-metric-chart-body",
    style: {
      width: bodyWidth,
      position: "relative",
      marginLeft: "-1px",
      overflow: "auto",
      display: "flex",
      flexDirection: "column",
      marginTop: hideXAxis ? "1px" : "0px"
    },
    onMouseMove: (0, _tooltipHandlers.mouseMoveHandler)(tooltipDispatcher),
    onScroll: (0, _tooltipHandlers.scrollHandler)(tooltipDispatcher),
    onMouseLeave: (0, _tooltipHandlers.mouseLeaveHandler)(tooltipDispatcher)
  }, /*#__PURE__*/_react["default"].createElement(_ScrollableMetricChartBody.ScrollableMetricChartBody, {
    width: xAxisWidth,
    height: height,
    yAxisHeight: yAxisHeight,
    bars: chart,
    hideXAxis: hideXAxis,
    xAxisHeight: xAxisHeight,
    padding: padding,
    xScale: xScale,
    tickXFormat: tickXFormat,
    axisFormatter: axisFormatter
  }), !hideXUnits ? /*#__PURE__*/_react["default"].createElement(_XAxisLabel.XAxisLabel, {
    hideXUnits: hideXUnits,
    hideXAxis: hideXAxis,
    XAxisLabelHeight: XAxisLabelHeight,
    scrollableWidth: scrollableWidth,
    bodyWidth: bodyWidth,
    padding: padding,
    xAxisLabel: xAxisLabel
  }) : null)));
};